import { FC, ReactNode } from 'react'
import { Icon } from 'antd'

import PerIcon from '../Icon'
import { TShirtSize } from '../../util/types'
import { icons } from '../Icon/icons'

import './index.less'

export type IconIndicatorBackground = 'info' | 'success' | 'warning' | 'error' | 'default'

export interface IIconIndicatorProps {
  icon?: keyof typeof icons
  antdIcon?: string
  antdTheme?: 'filled' | 'outlined' | 'twoTone'
  size?: TShirtSize
  iconSize?: number
  background?: IconIndicatorBackground
  variant?: 'decoration' | 'clickable'
  tooltip?: string | ReactNode
}

export const IconIndicator: FC<IIconIndicatorProps> = ({
  icon,
  antdIcon,
  antdTheme = 'filled',
  background,
  size,
  variant,
  tooltip,
  iconSize = 16,
}) => {
  const base = 'per-icon-indicator'
  const modifiers: string[] = []

  if (!!background) {
    modifiers.push(base + '--bg-' + background)
  }

  if (!!size) {
    modifiers.push(base + '--size-' + size)
  }

  const renderIcon = () => {
    if (antdIcon) {
      return <Icon type={antdIcon} theme={antdTheme} style={{ fontSize: iconSize, color: 'white' }} />
    }

    if (icon) {
      return <PerIcon name={icon} color="white" size={iconSize} variant={variant} tooltip={tooltip} />
    }

    return null
  }

  return <div className={base + ' ' + modifiers.join(' ')}>{renderIcon()}</div>
}
